import { BookOpen, MessageCircle, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyToStartYourOrder() {
  return <section data-section-id="229203" id="chamada-à-ação-final" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 z-0 opacity-5 pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/studio_abstract_glow.png)] bg-cover bg-center bg-no-repeat mix-blend-multiply"></div>
      
      {}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-primary/5 via-transparent to-background pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center text-center max-w-4xl">
        <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-foreground">
          Quer produzir com a ITC+?
        </h2>
        
        <p className="text-lg md:text-xl text-muted-foreground mb-12 max-w-2xl font-default">
          Fale com nossa equipe e comece seu projeto.
        </p>

        <div className="flex flex-col items-center gap-6 w-full max-w-md mx-auto sm:max-w-none">
          {}
          <Button asChild size="lg" className="w-full sm:w-auto h-16 px-10 text-lg sm:text-xl rounded-full bg-primary text-primary-foreground shadow-xl shadow-primary/20 transition-all duration-300 hover:scale-105 hover:-translate-y-1">
            <Link to="https://wa.me/5511969100007">
              <MessageCircle className="mr-3 size-6" />
              Falar no WhatsApp
            </Link>
          </Button>

          {}
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center mt-2">
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-12 px-8 border-primary/20 hover:bg-primary/5 text-muted-foreground hover:text-primary rounded-full transition-colors">
              <Link to="https://itcmais.com/o-estudio/" newTab>
                <BookOpen className="mr-2 size-4" />
                Ver o estúdio
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}